import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faEnvelope, faPhone, faCalendar, faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#FF2300',
    height: '100vh',
    justifyContent: 'center',
    color: '#fff',
    position: 'relative',
  },
  profileImageContainer: {
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '3px solid #fff',
  },
  profileImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  userInfo: {
    textAlign: 'center',
    marginTop: '15px',
  },
  name: {
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
  },
  role: {
    fontSize: '14px',
    opacity: 0.8,
    fontWeight: 'regular',
    fontFamily: 'Arial, sans-serif',
  },
  contactInfo: {
    fontSize: '14px',
    marginTop: '5px',
    fontWeight: 'regular',
    fontFamily: 'Arial, sans-serif',
  },
  buttonContainer: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    width: '80%',
    maxWidth: '400px',
  },
  separator: {
    width: '100%',
    height: '0.5px',
    backgroundColor: '#fff',
    margin: '30px 0',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '10px',
  },
  button: {
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    color: '#fff',
    padding: '10px',
    borderRadius: '20px',
    margin: '5px 0',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    textDecoration: 'none',
  },
  buttonIcon: {
    marginRight: '10px',
  },
  iconContainer: {
    marginTop: '20px',
    display: 'flex',
    gap: '15px',
  },
  iconLink: {
    color: '#fff',
    fontSize: '24px',
    textDecoration: 'none',
  },
  footerContainer: {
    position: 'absolute',
    bottom: '0',
    width: '100%',
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    padding: '15px 0',
  },
  logo: {
    maxWidth: '100px',
    height: 'auto',
  },
};

function BernyCard() {
  return (
    <div style={styles.container}>
      <div style={styles.profileImageContainer}>
        <img src="/pictures/BernatClsa.jpeg" alt="Bernat Clapés" style={styles.profileImage} />
      </div>
      <div style={styles.userInfo}>
        <p style={styles.name}>Bernat Clapés</p>
        <p style={styles.role}>Marketing, Communications & Services</p>
        <p style={styles.contactInfo}>(+34) 687 745 402</p>
        <p style={styles.contactInfo}>bernatclsa@bether.ai</p>
      </div>
      <div style={styles.buttonContainer}>
        <a href="/register" target="_blank" style={styles.button}>
          <FontAwesomeIcon icon={faLink} style={styles.buttonIcon} /> Regístrate
        </a>
        <div style={styles.separator}></div>
        <p style={styles.sectionTitle}>¿Hablamos?</p>
        <a href="mailto:bernatclsa@bether.ai" style={styles.button}>
          <FontAwesomeIcon icon={faEnvelope} style={styles.buttonIcon} /> Mándame un correo
        </a>
        <a href="tel:+34687745402" style={styles.button}>
          <FontAwesomeIcon icon={faPhone} style={styles.buttonIcon} /> Llámame
        </a>
        <a href="/schedule" style={styles.button}>
          <FontAwesomeIcon icon={faCalendar} style={styles.buttonIcon} /> Reserva una sesión conmigo
        </a>
      </div>
      <div style={styles.iconContainer}>
        <a href="https://www.linkedin.com/in/bernat-clapés-28330921/" style={styles.iconLink} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faLinkedin} />
        </a>
        <a href="/vcf/bernatclsa.vcf" style={styles.iconLink} download>
          <FontAwesomeIcon icon={faAddressCard} />
        </a>
      </div>
      <div style={styles.footerContainer}>
        <a href="/">
          <img src="/BetherLogoLuminousOrange.png" alt="Bether Logo" style={styles.logo} />
        </a>
      </div>
    </div>
  );
}

export default BernyCard;
